// src/components/subComponents/SocialButton.tsx
import React, { ComponentType, FC, SVGProps } from 'react';

interface SocialButtonProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  shortLabel: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const SocialButton: FC<SocialButtonProps> = ({
  icon: Icon,
  label,
  shortLabel,
  onClick,
  disabled = false,
  className = '',
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`
      px-4 w-full h-[56px] flex items-center justify-center py-2 mb-3
      border-2 border-black rounded-full hover:bg-gray-100
      transition ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      ${className}
    `}
  >
    {React.createElement(Icon as any, { size: 24, className: 'mr-2' })}
    <span className='hidden lg:block'>{label}</span>
    <span className='block lg:hidden'>{shortLabel}</span>
  </button>
);

export default SocialButton;
